import request from '@/utils/request'

export function getTalentInfo() {
  return request({
    url: '/Talent/get',
    method: 'post'
  })
}

// 获取人才计划解读信息
export function getTalentPlanInfo(data) {
  return request({
    url: '/Plan/get',
    method: 'post',
    data
  })
}

// 获取人才政策解读信息
export function getTalentPolicyInfo(data) {
  return request({
    url: '/Policy/get',
    method: 'post',
    data
  })
}

// 获取招聘信息
export function getJob(data) {
  return request({
    url: '/Job/get',
    method: 'post',
    data
  })
}

// 获取人才推荐信息
export function getRecommend(data) {
  return request({
    url: '/Recommend/get',
    method: 'post',
    data
  })
}

// 收藏
export function collection(data) {
  return request({
    url: '/User/collection',
    method: 'post',
    data,
    
  })
}

// 获取人才政策详情数据
export function getInfo(data) {
  return request({
    url: '/Policy/getInfo',
    method: 'post',
    data
  })
}

// 获取人才政策详情是否收藏
export function getIsCollected(data) {
  return request({
    url: '/Policy/collect',
    method: 'post',
    data
  })
}


// 获取人才计划详情
export function getTalentPlanDetail(data) {
  return request({
    url: '/Plan/getInfo',
    method: 'post',
    data
  })
}

// 获取人才招聘详情
export function getJobDetail(data) {
  return request({
    url: '/Job/getInfo',
    method: 'post',
    data
  })
}

// 获取人才推荐详情
export function getRecommendDetail(data) {
  return request({
    url: '/Recommend/getInfo',
    method: 'post',
    data
  })
}